import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "input-quote-content"
};
var _hoisted_2 = {
  class: "max-one-line"
};
import { ref, computed, onMounted, onUnmounted } from '../../../../adapter-vue';
import TUIChatEngine, { TUIStore, StoreName, TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import Icon from '../../../common/Icon.vue';
import closeIcon from '../../../../assets/icon/icon-close.svg';
import { isPC, isUniFrameWork } from '../../../../utils/env';
import { decodeTextMessage } from '../../utils/emojiList';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: ['currentFunction'],
  setup(__props) {
    var props = __props;
    var TYPES = TUIChatEngine.TYPES;
    var quoteMessage = ref();
    onMounted(() => {
      TUIStore.watch(StoreName.CHAT, {
        quoteMessage: onQuoteMessageUpdated
      });
      TUIStore.watch(StoreName.CONV, {
        currentConversationID: onConversationIDUpdated
      });
    });
    onUnmounted(() => {
      TUIStore.unwatch(StoreName.CHAT, {
        quoteMessage: onQuoteMessageUpdated
      });
      TUIStore.unwatch(StoreName.CONV, {
        currentConversationID: onConversationIDUpdated
      });
    });
    var quoteContentText = computed(() => {
      var _quoteMessage$value, _quoteMessage$value$p;
      var _quoteContentText;
      switch ((_quoteMessage$value = quoteMessage.value) === null || _quoteMessage$value === void 0 ? void 0 : _quoteMessage$value.type) {
        case TYPES.MSG_TEXT:
          _quoteContentText = decodeTextMessage((_quoteMessage$value$p = quoteMessage.value.payload) === null || _quoteMessage$value$p === void 0 ? void 0 : _quoteMessage$value$p.text);
          break;
        case TYPES.MSG_IMAGE:
          _quoteContentText = TUITranslateService.t('TUIChat.图片');
          break;
        case TYPES.MSG_AUDIO:
          _quoteContentText = TUITranslateService.t('TUIChat.语音');
          break;
        case TYPES.MSG_VIDEO:
          _quoteContentText = TUITranslateService.t('TUIChat.视频');
          break;
        case TYPES.MSG_FILE:
          _quoteContentText = TUITranslateService.t('TUIChat.文件');
          break;
        case TYPES.MSG_CUSTOM:
          _quoteContentText = TUITranslateService.t('TUIChat.自定义');
          break;
        case TYPES.MSG_FACE:
          _quoteContentText = TUITranslateService.t('TUIChat.表情');
          break;
        default:
          _quoteContentText = TUITranslateService.t('TUIChat.消息');
          break;
      }
      return _quoteContentText;
    });
    function cancelQuote() {
      TUIStore.update(StoreName.CHAT, 'quoteMessage', {
        message: undefined,
        type: 'quote'
      });
    }
    function onQuoteMessageUpdated(options) {
      if (options !== null && options !== void 0 && options.message && (options === null || options === void 0 ? void 0 : options.type) === 'quote') {
        quoteMessage.value = options.message;
      } else {
        quoteMessage.value = undefined;
      }
    }
    function onConversationIDUpdated() {
      cancelQuote();
    }
    return (_ctx, _cache) => {
      return Boolean(_unref(quoteMessage)) && props.currentFunction !== 'audio' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['input-quote-container', !_unref(isPC) && 'input-quote-container-h5', _unref(isUniFrameWork) && 'input-quote-container-uni'])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(quoteMessage).nick || _unref(quoteMessage).from) + ": " + _toDisplayString(_unref(quoteContentText)), 1), _createVNode(Icon, {
        class: "input-quote-close-icon",
        file: _unref(closeIcon),
        width: "11px",
        height: "11px",
        onOnClick: cancelQuote
      }, null, 8, ["file"])])], 2)) : _createCommentVNode("", true);
    };
  }
});